import { render, staticRenderFns } from "./GlossaryTermForm.vue?vue&type=template&id=06061ad5&scoped=true&"
import script from "./GlossaryTermForm.vue?vue&type=script&lang=js&"
export * from "./GlossaryTermForm.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryTermForm.vue?vue&type=style&index=0&id=06061ad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06061ad5",
  null
  
)

export default component.exports